import { isSameDay } from 'date-fns/isSameDay';
import { useMemo } from 'react';

import { getZonedDate } from '@eika-infrastruktur/date';

import type { AccountNumber } from '../../../../generated-types';
import { FormattedFuturePayment } from '../../../../utils/mapper/futurepaymentsUtil';
import { TransferState } from '../form/state';

const accountNumberHasChanged = (initialAccount?: AccountNumber, stateAccount?: AccountNumber) => {
    return initialAccount?.value !== stateAccount?.value;
};

const useHasChanged = (
    state: TransferState,
    futurePayment: FormattedFuturePayment,
    receiverText: string | undefined,
    ownText: string | undefined,
) => {
    return useMemo(() => {
        const toAccountHasChanged = accountNumberHasChanged(futurePayment.toAccount.accountNumber, state.toAccount);
        const fromAccountHasChanged = futurePayment.fromAccount.accountNumber?.value !== state.fromAccount?.value;
        const amountHasChanged = Math.abs(futurePayment.amount) !== state.amount;
        const noteHasChanged = (receiverText ?? (futurePayment.description || '')) !== state.note;
        const dateHasChanged = !isSameDay(getZonedDate(futurePayment.date), getZonedDate(state.transferDate));
        const ownTextHasChanged = ownText !== state.ownText;
        return (
            toAccountHasChanged ||
            fromAccountHasChanged ||
            amountHasChanged ||
            noteHasChanged ||
            ownTextHasChanged ||
            dateHasChanged
        );
    }, [futurePayment, state, receiverText, ownText]);
};

export default useHasChanged;
